import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "body xs font-regular row gap-1 align-center select-label",
  for: "select"
}
const _hoisted_2 = { class: "chevron-icon" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "row gap-1 error-message"
}
const _hoisted_5 = { class: "body xs font-regular" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import { FormSelectOption } from '@/models/select-props-interfaces';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSelect',
  props: {
    label: {},
    placeHolder: {},
    modelValue: {},
    required: { type: Boolean },
    error: { type: Boolean },
    errorMessage: {},
    aditionalInfo: {},
    disabled: { type: Boolean },
    options: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showOptions = ref(false);
const internalValue = ref(props.modelValue);
const focusedIndex = ref<number | undefined>(undefined);
const customSelectRef = ref<HTMLElement | null>(null);
const optionsRight = ref<'0' | 'auto'>('0');

function toggleOptions() {
  if (props.disabled) return;
  showOptions.value = !showOptions.value;
  if (!showOptions.value) focusedIndex.value = undefined;
}

function emitSelection() {
  emit('update:modelValue', internalValue.value);
}

function selectOption(value: string | number) {
  internalValue.value = value;
  emitSelection();
  showOptions.value = false;
  (document.activeElement as HTMLElement)?.blur();
}

function handleOutsideClick(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!target.closest('.custom-select')) {
    showOptions.value = false;
    focusedIndex.value = undefined;
  }
}

function handleKeydown(event: KeyboardEvent) {
  if (!showOptions.value) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleOptions();
    }
    return;
  }
  if (event.key === 'ArrowDown') {
    event.preventDefault();
    focusedIndex.value =
      focusedIndex.value === undefined
        ? 0
        : (focusedIndex.value + 1) % props.options.length;
  } else if (event.key === 'ArrowUp') {
    event.preventDefault();
    focusedIndex.value =
      focusedIndex.value === undefined
        ? props.options.length - 1
        : (focusedIndex.value - 1 + props.options.length) %
          props.options.length;
  } else if (event.key === 'Enter' && focusedIndex.value !== undefined) {
    event.preventDefault();
    selectOption(props.options[focusedIndex.value].value);
  } else if (event.key === 'Escape') {
    event.preventDefault();
    showOptions.value = false;
    focusedIndex.value = undefined;
  }
}

function clearFocusedIndex() {
  focusedIndex.value = undefined;
}

function handleResize() {
  if (!customSelectRef.value) return;
  optionsRight.value = customSelectRef.value.offsetWidth < 80 ? 'auto' : '0';
}

if (!props.disabled) {
  watch(
    () => props.modelValue,
    (newValue) => {
      internalValue.value = newValue;
    }
  );
  onMounted(() => {
    document.addEventListener('click', handleOutsideClick);
    if (customSelectRef.value) {
      const resizeObserver = new ResizeObserver(() => handleResize());
      resizeObserver.observe(customSelectRef.value);
    }
    handleResize();
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleOutsideClick);
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["column gap-1 select-wrapper", { disabled: _ctx.disabled }]),
    onKeydown: handleKeydown,
    tabindex: "0"
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(["body xs", { required: !_ctx.disabled }])
              }, "*", 2))
            : _createCommentVNode("", true),
          (_ctx.aditionalInfo)
            ? (_openBlock(), _createBlock(CustomTooltip, {
                key: 1,
                message: _ctx.aditionalInfo
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    name: "info",
                    size: "body-s",
                    className: "aditional-info"
                  })
                ]),
                _: 1
              }, 8, ["message"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["custom-select", { active: showOptions.value, error: _ctx.error }]),
      role: "listbox",
      onClick: toggleOptions,
      ref_key: "customSelectRef",
      ref: customSelectRef
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(["text-value", {
          'color-lighter': internalValue.value === undefined || internalValue.value === null
        }])
      }, _toDisplayString(internalValue.value === undefined || internalValue.value === null
            ? _ctx.placeHolder
            : _ctx.options.find((option) => option.value === internalValue.value)?.label), 3),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppIcon, { name: "chevron-down" })
      ]),
      (showOptions.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "select-options",
            style: _normalizeStyle({ right: optionsRight.value })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.value,
                class: _normalizeClass(["option", { focused: index === focusedIndex.value }]),
                role: "listitem",
                onClick: ($event: any) => (selectOption(option.value)),
                onMouseenter: clearFocusedIndex
              }, [
                (option.icon)
                  ? (_openBlock(), _createBlock(AppIcon, {
                      key: 0,
                      name: option.icon.name,
                      size: option.icon.size
                    }, null, 8, ["name", "size"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(option.label), 1)
              ], 42, _hoisted_3))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.error && _ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(AppIcon, {
            name: "info",
            size: "body-s"
          }),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})